import React from "react";

export const ScreensContext = React.createContext({
  endSessionType: "NOT_MOBILE",
  setEndSessionType: () => {},
  isDisplayedAll: false,
});
